module.exports = __webpack_public_path__ + "static/media/ss_1_en.adb17f3a.jpg";